import * as types from '../actions/actionTypes';
import initialState from './initialState';
        
export default function preguntarespuestaReducer(state= initialState.preguntarespuesta, action){
    let newState;
	switch(action.type){
         case types.LOAD_PREGUNTARESPUESTA_LIST_SUCCESS:		
            action.preguntarespuesta.filtroActivo=state.filtroActivo;
            action.preguntarespuesta.filtroActual=state.filtroActual;
            action.preguntarespuesta.showActivos=state.showActivos;
			 action.preguntarespuesta.paginaActual=action.preguntarespuesta.pageable.pageNumber;
			 action.preguntarespuesta.registrosPorPagina=action.preguntarespuesta.size;
            
            return action.preguntarespuesta;

        case types.BORRAR_PREGUNTARESPUESTA_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(preguntarespuesta => preguntarespuesta.id !== action.preguntarespuesta.id)];          
			return newState;    
            
        case types.ACTIVAR_PREGUNTARESPUESTA_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(preguntarespuesta => preguntarespuesta.id !== action.preguntarespuesta.id)];          
			 return newState;
            
        case types.SET_FILTRO_PREGUNTARESPUESTA:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}